import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EmptyListIcon } from '@/shared/assets/icons/empty-list-icon';

export const EmptyTable = () => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      gap="0.5rem"
      alignItems="center"
      height="100%"
      minHeight="75px"
      justifyContent="center"
    >
      <EmptyListIcon size="1.25rem" variant="primary" />
      <Typography variant="p7">{t('ui:no_items_yet')}</Typography>
    </Stack>
  );
};
